module.exports = __webpack_public_path__ + "04b20938a5a4c8a92b2a7d16beaede92.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/head/traumweltstadt.jpg
// module id = 911
// module chunks = 0